import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { supplyPointQueries } from '@/features/supply-points/queries.ts';
import {
  getStoredSupplyPointId,
  resolveActiveSupplyPointId,
} from '@/features/supply-points/utils/resolveActiveSupplyPoint.ts';

export const Route = createFileRoute('/_authenticated/_supply-point-scope')({
  loader: async ({ context }) => {
    const supplyPoints = await context.queryClient.ensureQueryData(supplyPointQueries.list());

    if (supplyPoints.length === 0) {
      throw redirect({ to: '/no-supply-points' });
    }

    const activeId = resolveActiveSupplyPointId(supplyPoints, getStoredSupplyPointId());
    const activeSupplyPoint = supplyPoints.find((sp) => sp.id === activeId) ?? supplyPoints[0];

    return {
      breadcrumb: activeSupplyPoint.name,
    };
  },
  component: Outlet,
});
